import React__default from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

var FRONT_EDIT_SIDE_BAR_TAB;
(function (FRONT_EDIT_SIDE_BAR_TAB) {
    FRONT_EDIT_SIDE_BAR_TAB["PAGES"] = "pages";
    FRONT_EDIT_SIDE_BAR_TAB["GENERAL_SETTINGS"] = "general_settings";
})(FRONT_EDIT_SIDE_BAR_TAB || (FRONT_EDIT_SIDE_BAR_TAB = {}));
var FrontEditSideBar = function (_a) {
    var className = _a.className, _b = _a.testId, testId = _b === void 0 ? "FrontEditSideBar" : _b, pagesComponent = _a.pagesComponent, generalSettingsComponent = _a.generalSettingsComponent, onTabChange = _a.onTabChange, currentTab = _a.currentTab;
    var t = useTranslation("refront-components").t;
    return (React__default.createElement(Box, { className: clsx("FrontEditSideBar", className), "data-testid": testId, sx: { width: "100%", typography: "body1" } },
        React__default.createElement(TabContext, { value: currentTab },
            React__default.createElement(Box, { sx: { backgroundColor: "grey.100" } },
                React__default.createElement(TabList, { onChange: onTabChange, "aria-label": t("components-front-edit.sideBar.tabs.aria.label"), variant: "fullWidth" },
                    React__default.createElement(Tab, { label: t("components-front-edit.sideBar.tab.pages.label"), value: FRONT_EDIT_SIDE_BAR_TAB.PAGES }),
                    React__default.createElement(Tab, { label: t("components-front-edit.sideBar.tab.generalSettings.label"), value: FRONT_EDIT_SIDE_BAR_TAB.GENERAL_SETTINGS }))),
            React__default.createElement(TabPanel, { value: FRONT_EDIT_SIDE_BAR_TAB.PAGES }, pagesComponent),
            React__default.createElement(TabPanel, { value: FRONT_EDIT_SIDE_BAR_TAB.GENERAL_SETTINGS }, generalSettingsComponent))));
};

export { FRONT_EDIT_SIDE_BAR_TAB, FrontEditSideBar as default };
//# sourceMappingURL=index.js.map
